module.exports = __webpack_public_path__ + "static/media/twitterIcon.99dbe405.png";